import {TrendingUp,TrendingDown,Wallet} from "lucide-react";

const MONTHS = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

export function OverviewCard({viewMode, totalIncome, totalExpenses, netBalance, incomes, expenses, selectedMonth, selectedYear}) {
    const periodoLabel = viewMode === 'annual' ? `${selectedYear}` : `${MONTHS[selectedMonth]} ${selectedYear}`;
    return (
        <div className="row g-4 mb-4">
            <div className="col-12 col-md-4">
                <div className="card custom-card h-100">
                    <div className="card-body p-4">
                        <div className="d-flex align-items-start justify-content-between">
                            <div>
                                <p className="small text-muted-custom mb-2">
                                    Receita — {periodoLabel}
                                </p>
                                <h3 className="h2 fw-bold text-primary-custom mb-1">
                                    R${totalIncome ? totalIncome.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00'}
                                </h3>
                                <p className="small text-muted-custom mb-0">{incomes ? incomes.length : 0} Fontes</p>
                            </div>
                            <div className="icon-container icon-container-custom" style={{backgroundColor: 'rgba(0,255,136,0.2)'}}>
                                <TrendingUp size={24} className="text-primary-custom" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-md-4">
                <div className="card custom-card h-100">
                    <div className="card-body p-4">
                        <div className="d-flex align-items-start justify-content-between">
                            <div>
                                <p className="small text-muted-custom mb-2">Gastos — {periodoLabel}</p>
                                <h3 className="h2 fw-bold text-danger-custom mb-1">R${totalExpenses ? totalExpenses.toLocaleString('pt-BR', {minimumFractionDigits:2,maximumFractionDigits: 2}) : '0,00'}</h3>
                                <p className="small text-muted-custom mb-0">{expenses ? expenses.length : 0} Gastos</p>
                            </div>
                            <div className="icon-container icon-container-custom" style={{ backgroundColor: 'rgba(239, 68, 68, 0.2)'}}>
                                <TrendingDown size={24} className="text-danger-custom" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-md-4">
                <div className="card custom-card h-100">
                    <div className="card-body p-4">
                        <div className="d-flex align-items-start justify-content-between">
                            <div>
                                <p className="small text-muted-custom mb-2">Balanço</p>
                                <h3 className={`h2 fw-bold mb-1 ${netBalance >= 0 ? 'text-primary-custom' : 'text-danger-custom'}`}>R${netBalance ? Math.abs(netBalance).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00'}</h3>
                                <p className="small text-muted-custom mb-0">{netBalance >= 0 ? 'Disponível' : 'Acima do orçamento'} — {periodoLabel}</p>
                            </div>
                            <div className="icon-container icon-container-custom" style={{ backgroundColor: netBalance >= 0 ? 'rgba(0, 255, 136, 0.2)' : 'rgba(239, 68, 68, 0.2)'}}>
                                <Wallet size={24} style={{ color: netBalance >= 0 ? 'var(--color-primary)' : 'var(--color-danger)' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}